module.exports = __webpack_public_path__ + "img/b6.10ba4d25.png";